<script>
    import { saveFiles, releaseAndUnreleaseFile } from '@/api/file.js';

    export default {
        props: {
            file: Object,

            additionalSetting: Boolean,
            toggleAdditionalSetting: Function,
        },
        computed: {
            assetTypeID() { return this.$store.getters.ASSET_TYPE_IMAGES },
        },
        methods: {
            async toggleHightQuality() {
                this.file.toggleHQ();
            },
            async toggleAS() {
                this.toggleAdditionalSetting();
            },
            async saveFile() {
                const response = await saveFiles(this.file, this.assetTypeID);
                if (response.length > 0) await this.file.updateFileData(response[0]);
            },
            async realeseFile() {
                const response = await releaseAndUnreleaseFile(this.assetTypeID, [this.file.id]);
                if (response === true) await this.file.toggleReleaseStatus();
            },
            async unrealeseFile() {
                const response = await releaseAndUnreleaseFile(this.assetTypeID, [], [this.file.id]);
                if (response === true) await this.file.toggleReleaseStatus();
            }
        }
    }
</script>


<template>
    <div class="image_header_container">
        <div class="image_header_button">
            <button
                :disabled="file['isEdit'] === false" 
                class="button_blue_150"
                @click="saveFile"
            >
                Save
            </button>
            <button 
                class="button_blue_150 button_red ml_10"
                v-if="file['isReleased'] === false"
                @click="realeseFile"
            >
                Realese
            </button>
            <button
                class="button_blue_150 ml_10"
                v-else
                @click="unrealeseFile"
            >
                Unrealese
            </button>
            <div 
                @click="toggleHightQuality"
                :class="file['isHq'] === false ? 
                'ml_10 toggle_button tb_disable' : 
                'ml_10 toggle_button tb_active'"
            >
                Hight Quality
            </div>
            <div 
                @click="toggleAS"
                :class="additionalSetting === false ? 
                'ml_10 toggle_button tb_disable' : 
                'ml_10 toggle_button tb_active'"
            >
                Additional Settings
            </div>
            <button
                v-if="file['origin'] === 'gup'"
                type="button"
                :aria-pressed="file['toDelete'] === true"
                :class="file['toDelete'] === true ? 'ml_10 to_delete to_delete_on' : 'ml_10 to_delete'"
                title="Mark for erase: off the shelves, out of S3 and the database, and GUP won't upload it again"
                @click="file.toggleToDelete()"
            >{{ file['toDelete'] === true ? '☒' : '☐' }} To deletion</button>
            <div class="ml_10 image_text_container">
                <label>{{ file['resolution'] }}</label>
            </div>
        </div>
        <div class="image_header_text">
            <label>[{{ file['id'] }}]</label>
            <label class="ml_5">{{ file['name'] }}</label>
        </div>
    </div>
</template>


<style scoped>
    .image_header_container {
        display: flex;
        padding: 5px;
    }
    
    .image_text_container {
        width: 150px;
        display: inline-block;

        font-weight: bold;
        text-align: center;

        background-color: var(--background);
        /* border-left: 2px solid var(--background-separator); */
        /* border-right: 2px solid var(--background-separator); */
        border-radius: 5px;
    }

    /* Sized by its buttons, on one line: a fixed 800px wrapped the resolution
       under Save once GUP rows got "To deletion" (869fhht95). */
    .image_header_button {
        flex: 0 0 auto;
        white-space: nowrap;
    }

    .toggle_button {
        width: 150px;
        display: inline-block;

        border-radius: 5px;

        font-weight: bold;
        text-align: center;

        cursor: pointer;
        user-select: none;
    }

    .tb_disable {
        border: 1px solid var(--header-separator);
    }
    .tb_disable:hover {
        background-color: var(--left-toggle-hover);
        border: 1px solid transparent;
    }
    .tb_active {
        color: var(--header-button-text);
        background-color: var(--header-button);
        border: 1px solid transparent;
    }
    .tb_active:hover {
        background-color: var(--header-button-hover);
    }


    .image_header_text {
        flex: 1 1 100%;

        text-align: center;
        display: table-cell;
        vertical-align: middle;

        font-weight: bold;
    }
    /* 869fhgjpg: the mark for the sticky Delete above the list. */
    .to_delete {
        width: 150px;
        border: 1px solid #fc424a;
        border-radius: 5px;
        background-color: transparent;
        color: inherit;
        cursor: pointer;
    }
    .to_delete_on {
        background-color: #fc424a;
        color: #ffffff;
    }
</style>